import { parseTelemetryEnv } from '@lunacast/lib-telemetry';
import type { TelemetryInitOptions } from '@lunacast/lib-telemetry';

const telemetryEnv = parseTelemetryEnv(
  import.meta.env as Record<string, string | undefined>,
);

/** overlay-web용 Application Insights·Clarity 초기화 옵션이다. `cloudRoleName`은 이 앱으로 고정한다. */
export const telemetryInitOptions: TelemetryInitOptions = {
  enabled: telemetryEnv.enabled,
  connectionString: telemetryEnv.connectionString,
  clarityProjectId: telemetryEnv.clarityProjectId,
  cloudRoleName: 'overlay-web',
};
